import { getDealershipDepartment } from "./getDealershipDepartment.js";
const formatDealershipPhones = (dealershipItem) => {
  var _a;
  const department = getDealershipDepartment(dealershipItem);
  if (!department) {
    return [];
  }
  return (_a = department.contacts) == null ? void 0 : _a.filter(({ phones, apps }) => !!(phones == null ? void 0 : phones.length) && (apps == null ? void 0 : apps.includes("instock"))).flatMap(({ phones }) => phones);
};
export {
  formatDealershipPhones
};
